import React, { useState, useMemo } from 'react';
import Account from './Account';
import Login from './Login';
import Main from './Main';
import ServerNotificationModal from './Components/Notification/ServerNotificationModal';
import AuctionInfoModal from './Components/AuctionInfoModal';
import { useMessageStore, usePlayerStore, useInventoryStore, useCraftStore, useAbilityStore, useLearnStore, useVaultStore } from './store/store';
import useUserBuffStore from './store/userBuffStore';

let socket = null;

// const URL = "ws://localhost:9999";
const URL = "wss://cl.cursed-lands.net";

export const AppState = React.createContext();


function Home() {

    const [loggedIn, setLoggedIn] = useState(false);
    const [connected, setConnected] = useState(false);
    const [connecting, setConnecting] = useState(false);
    const [characterList, setCharacterList] = useState([{ id: 1, name: "test", picId: 1, level: 24, race: "Human", clazz: "Warrior" }]);
    const [playing, setPlaying] = useState(false);
    const [roomListPlayers, setRoomListPlayers] = useState([]);
    const [roomListMobs, setRoomListMobs] = useState([]);
    const [selfTargeted, setSelfTargeted] = useState(false);

    const [mapGrid, setMapGrid] = useState([]);
    const [position, setPosition] = useState([5, 5]);
    const [roomInformation, setRoomInfo] = useState({ area: "area", title: "title", exits: "exits", desc: "desc", items: [] });
    const [stamina, setStamina] = useState({ type: '', duration: '' });
    const [buffs, setBuffs] = useState([]);
    const [shopList, setShopList] = useState([]);
    const [shopInfo, setShopInfo] = useState([]);
    const [createInfo, setCreateInfo] = useState(null);
    const [cooldowns, setCooldowns] = useState([]);
    const [notifications, setNotifications] = useState({ showTrade: false, showParty: false });
    const [serverNotification, setServerNotification] = useState({ show: false, title: '', message: '' });
    const [auctionInfoModalOpen, setAuctionInfoModalOpen] = useState(false);
    const [auctionItemInfo, setAuctionItemInfo] = useState(null);

    var mobs = [];
    var players = [];



    function registerAccount(username, password, email) {
        if (socket === null) {
            setConnecting(true);
            socket = new WebSocket(URL);
            socket.addEventListener("open", event => {
                setConnected(true);
                console.log("connection opened");
                socket.send("001" + username + password + ";" + email);
            });
            socket.addEventListener("close", event => {
                setConnected(false);
                setConnecting(false);
                setLoggedIn(false);
                setPlaying(false);
                console.log("connection closed");
                socket.close();
                socket = null;
            });
            socket.addEventListener("message", event => {
                const splitData = event.data.split("!#~");
                for (let i = 0; i < splitData.length; i++) {
                    parseData(splitData[i]);
                }
            });
            socket.addEventListener("error", event => {
                console.log("there was an error!");
            });
        } else {
            setConnecting(false);
        }
    }

    function connect(username, password) {
        if (socket == null) {
            setConnecting(true);
            socket = new WebSocket(URL);
            socket.addEventListener("open", event => {
                setConnected(true);
                console.log("connection opened");
                socket.send("000" + username + password);
            });
            socket.addEventListener("close", event => {
                setConnected(false);
                setConnecting(false);
                setLoggedIn(false);
                setPlaying(false);
                console.log("connection closed");
                socket.close();
                socket = null;
            });
            socket.addEventListener("message", event => {
                const splitData = event.data.split("!#~");
                for (let i = 0; i < splitData.length; i++) {
                    parseData(splitData[i]);
                }
            });
            socket.addEventListener("error", event => {
                console.log("there was an error!");
            });
        } else {
            setConnecting(false);
        }
    }

    const messageHandlers = {
        "200": (data) => {
            // Parse server notification data in format "TITLE-Message"
            const dashIndex = data.indexOf('-');
            if (dashIndex !== -1) {
                const title = data.substring(0, dashIndex);
                const message = data.substring(dashIndex + 1);
                setServerNotification({ show: true, title, message });
            } else {
                // Fallback if format is unexpected
                setServerNotification({ show: true, title: 'Server Message', message: data });
            }
        },
        "020": (data) => {
            //update email....
        },
        "004": (data) => {
            setLoggedIn(true);
            const splitChar = data.split("/");
            const characters = [];
            for (let i = 0; i < splitChar.length - 1; i++) {
                const charInfo = splitChar[i].split("-");
                const picId = charInfo[0];
                const name = charInfo[1];
                const level = charInfo[2];
                const race = charInfo[3];
                const clazz = charInfo[4];
                characters.push({ id: i, name: name, picId: picId, level: level, race: race, clazz: clazz });
            }
            setCharacterList(characters);
        },
        "002": (data) => {
            const pSplit = data.split('-');
            const pInfo = {
                picId: pSplit[0],
                name: pSplit[1],
                level: pSplit[2],
                race: pSplit[3],
                clazz: pSplit[4]
            };
            // setPlayerInfo(pInfo);
            usePlayerStore.getState().setInfo(pInfo);
            setPlaying(true);
        },
        "100": (data) => updateCreateCharacter(data),
        "312": (data) => {
            mobs = [];
            players = [];
            setSelfTargeted(false); // Clear self-targeting when entering new room
            setRoomListMobs(mobs);
            setRoomListPlayers(players);
        },
        "303": (data) => updateStamina(data),
        "301": (data) => updateHealth(data),
        "302": (data) => updateMana(data),
        "304": (data) => updateExperience(data),
        "315": (data) => updateGold(data),
        "300": (data) => usePlayerStore.getState().updatePlayerStats(data),
        "306": (data) => updateMapPosition(data),
        "305": (data) => updateMap(data),
        "314": (data) => updateRoomInfo(data),
        "326": (data) => updateCooldown(data),
        "345": (data) => {
            if (data === "self") {
                // Target self - clear all other selections and set self as targeted
                setSelfTargeted(true);
                mobs.forEach(m => {
                    m.selected = false;
                })
                players.forEach(p => {
                    p.selected = false;
                })
                setRoomListMobs([...mobs]);
                setRoomListPlayers([...players]);
            } else {
                // Clear self-targeting when selecting other targets
                setSelfTargeted(false);

                if (data.includes('/')) {
                    const split = data.split("/");
                    // const isMob = split[0] === true;
                    const id = split[2];

                    mobs.forEach(m => {
                        if (m.id === id) {
                            m.selected = true;
                        } else {
                            m.selected = false;
                        }
                    })

                    players.forEach(p => {
                        if (p.id === id) {
                            p.selected = true;
                        } else {
                            p.selected = false;
                        }
                    })

                } else if (data === "clear") {
                    mobs.forEach(m => {
                        m.selected = false;
                    })
                    players.forEach(p => {
                        p.selected = false;
                    })
                }
                setRoomListMobs([...mobs]);
                setRoomListPlayers([...players]);
            }
        },
        "307": (data) => {
            const split = data.split("/");
            if (split.length === 6) {
                const picId = split[0];
                const name = split[1];
                const hp = parseInt(split[2]);
                const friendStatus = split[3];
                // const sneak = split[4];
                const level = split[5];

                const index = players.findIndex((player) => player.name === name);
                if (index === -1) {
                    players.push({ type: "player", id: name, name: name, level: level, picId: picId, hp: hp, friendStatus: friendStatus, attacking: 0, selected: false });
                } else {
                    players[index].hp = hp;
                }
                setRoomListPlayers([...players]);

            } else if (split.length >= 7) {
                // const pet = split[0]
                const id = split[1];
                const picId = split[2];
                const name = split[3];
                const hp = parseInt(split[4]);
                const friendStatus = parseInt(split[5]);
                // const sneak = split[6];
                const level = split[7];
                const actions = [];
                const attacking = 0;

                if (split.length === 9) {
                    const action = split[8].split(';');
                    action.forEach(a => {
                        a.length > 0 && actions.push(a);
                    });
                }

                const index = mobs.findIndex((mob) => mob.id === id);
                if (index === -1) {
                    mobs.push({ type: "mob", id: id, name: name, level: level, picId: picId, hp: hp, friend: friendStatus, actions: actions, attacking: attacking, selected: false });
                } else {
                    mobs[index].hp = hp;
                }
                setRoomListMobs([...mobs]);
            }
        },
        "308": (data) => updateDisplay(data),
        "311": (data) => {
            mobs = mobs.filter((m) => m.id !== data);
            players = players.filter((p) => p.name !== data);
            setRoomListMobs(mobs);
            setRoomListPlayers(players);
        },
        "317": (data) => updateTrainerInfo(data),
        "318": (data) => updateAbilityInfo(data),
        "319": (data) => updateInventory(data),
        "320": (data) => updateEquipment(data),
        "322": (data) => updateInventoryInfo(data),
        "323": (data) => updateShop(data),
        "324": (data) => updateShopInfo(data),
        "501": (data) => {
            setBuffs([]);
            updateBuffs(data);
        },
        "502": (data) => removeBuff(data),
        "604": (data) => {
            const stats = data.split(';');

            const points = parseInt(stats[6]);
            usePlayerStore.getState().setStatPoints(points);
        },
        "605": (data) => updateAggro(data),
        "503": (data) => updateRoomItems(data),
        "800": (data) => updateNotification(data),
        "801": (data) => updateCraft(data),
        "802": (data) => updateCraftInfo(data),
        "329": (data) => updateAbilities(data),
        "330": (data) => updateAbilitiesInfo(data),
        "850": (data) => openVault(data),
        "853": (data) => updateVaultInfo(data),
        "854": (data) => updateBankBalance(data),
        "857": (data) => updateVaultList(data),
        "327": (data) => updateUserBuffs(data),
        "328": (data) => removeUserBuffs(data),
        "858": (data) => updateVaultUpgradeCost(data),
        "403": (data) => {
            const itemInfo = getItemInfo(data);
            setAuctionItemInfo(itemInfo);
            setAuctionInfoModalOpen(true);
        }
    };

    function parseData(recieved) {
        const type = recieved.substring(0, 3);
        const data = recieved.substring(3, recieved.length);

        const handler = messageHandlers[type];
        if (handler) {
            handler(data);
        }
    }

    function openVault(data) {
        const id = data;
        useVaultStore.getState().setId(id);
        useVaultStore.getState().setShow(true);
    }

    function updateBankBalance(data) {
        const balance = parseInt(data);
        useVaultStore.getState().setBalance(balance);
    }

    function updateVaultInfo(data) {

        const mid = data.substring(0, data.indexOf(';'));
        const info = data.substring(mid.length + 1, data.length);
        useVaultStore.getState().setItemInfo(getItemInfo(info));
    }

    function updateVaultList(data) {
        useVaultStore.getState().updateVault(data);
    }

    function updateVaultUpgradeCost(data) {
        const cost = parseInt(data);    
        useVaultStore.getState().setUpgradeCost(cost);
    }

    function updateAbilities(data) {
        const { id, points, abilities } = parseAbilityList(data);
        useAbilityStore.getState().setId(id);
        useAbilityStore.getState().setPoints(points);
        useAbilityStore.getState().setAbilities(abilities);
        useAbilityStore.getState().setShow(true);
    }

    function updateAbilitiesInfo(data) {
        const info = parseAbilityInfo(data);
        useAbilityStore.getState().setAbilityInfo(info);
    }

    function updateNotification(data) {
        const i = parseInt(data);

        switch (i) {
            case 1: setNotifications(prev => ({ ...prev, showParty: true }));
                break;
            case 2: setNotifications(prev => ({ ...prev, showTrade: true }));
                break;
            case 3: setNotifications(prev => ({ ...prev, showParty: false }));
                break;
            case 4: setNotifications(prev => ({ ...prev, showTrade: false }));
                break;
            default:
                break;
        }
    }

    function updateCooldown(data) {
        const s = data.split(';');
        const picId = parseInt(s[0]);
        const name = s[1];
        const time = parseInt(s[2]);
        const createdAt = Date.now();
        setCooldowns(prev => [...prev, { picId, name, time, createdAt }]);
    }

    function removeCooldowns(curTime) {
        setCooldowns(prev => prev.filter(e => { return ((e.createdAt + e.time) > curTime) }));
    }

    function updateRoomItems(data) {
        const parse = data.split('~');
        const updateItems = parseRoomItems(parse[1]);
        setRoomInfo((prev) => ({ ...prev, items: updateItems }));
    }


    function parseRoomItems(data) {

        if (!data.includes('/')) {
            return [];
        }

        const split = data.split('/');
        const roomItem = [];

        split.forEach(e => {
            const p2 = e.split(':');
            if (p2.length > 4) {
                const picId = parseInt(p2[0]);
                const name = p2[1];
                const qty = p2[2];
                // const unique = p2[3] === "true";
                const colour = p2[4].replace("{c}", "#");
                // const type = p2[5];
                // const slot = p2[6];
                // const tag = "";
                roomItem.push({ picId, name, qty, colour });
            }
        });

        return roomItem;
    }

    function updateCreateCharacter(data) {
        const details = data.split('_');
        const raceDetails = details[0];
        const classDetails = details[1];
        const statPoints = details[2];

        const er = raceDetails.split('/');
        const races = [];
        for (let i = 0; i < er.length - 1; i++) {
            const rd = er[i].split(';');
            const rname = rd[0];
            const raceDesc = rd[1];
            const str = parseInt(rd[2]);
            const agi = parseInt(rd[3]);
            const tog = parseInt(rd[4]);
            const intel = parseInt(rd[5]);
            const wis = parseInt(rd[6]);
            const chr = parseInt(rd[7]);
            const raceAttributes = rd[8].split('~');

            races.push({ name: rname, description: raceDesc, str, agi, tog, intel, wis, chr, raceAttributes });
        }

        const ec = classDetails.split("/");
        const classList = [];
        for (let i = 0; i < ec.length - 1; i++) {
            const cd = ec[i].split(";");
            const className = cd[0];
            const classDesc = cd[1];
            // const attribs = cd[3];
            classList.push({ name: className, description: classDesc });
        }

        const info = { statPoints, races, classList };
        setCreateInfo(info);
    }

    function updateTrainerInfo(data) {
        const { id, points, abilities } = parseAbilityList(data);
        useLearnStore.getState().setId(id);
        useLearnStore.getState().setPoints(points);
        useLearnStore.getState().setAbilities(abilities);
        useLearnStore.getState().setShow(true);
    }

    function parseAbilityList(data) {
        const info = data.split('~');
        const id = info[0].split(' ');
        const abil = [];

        for (let i = 1; i < info.length; i++) {
            const ability = info[i].split(';');
            if (ability.length > 1) {
                const picId = parseInt(ability[0]);
                const isSpell = ability[1];
                const name = ability[2];
                const level = parseInt(ability[3]);
                const cap = parseInt(ability[4]);
                const type = ability[5];
                const b = ability[6] === "1";
                abil.push({ picId: picId, isSpell: isSpell, name: name, level: level, cap: cap, type: type, b: b });
            }

        }
        return { id: id[0], points: id[1], abilities: abil };
    }

    function parseAbilityInfo(data) {
        const info = data.split(';');
        if (info.length >= 4) {
            const reqs = parseAbilityRequirements(info[0]);
            const mods = parseAbilityModifiers(info[1]);
            const name = info[2];
            const level = parseInt(info[3]);
            const desc = info[4];
            const type = info[5];
            const type2 = info[6];
            let castTime = 0;
            let cooldown = 0;
            let reuse = 0;
            if (info.length === 9) {
                castTime = parseInt(info[7]);
                cooldown = parseInt(info[8]);
            }else if (info.length === 10) {
                castTime = parseInt(info[7]);
                reuse = parseInt(info[8]);
                cooldown = parseInt(info[9]);
            }
            return { name: name, level: level, desc: desc, type: type, requirements: reqs, modifiers: mods, type2: type2, castTime: castTime, cooldown: cooldown, reuse: reuse };
        }
    }

    function updateAbilityInfo(data) {
        const info = parseAbilityInfo(data);
        useLearnStore.getState().setAbilityInfo(info);
    }

    function updateAggro(data) {
        const info = data.split(';');
        const id = info[0];
        const isMob = parseInt(info[1]) === 1;
        const isAggro = parseInt(info[2]);

        if (!isMob) {
            const index = players.findIndex((player) => player.name === id);
            if (index !== -1) {
                players[index].attacking = isAggro;
            }
            setRoomListPlayers([...players]);
        } else {
            const index = mobs.findIndex((mob) => mob.id === id);
            if (index !== -1) {
                mobs[index].attacking = isAggro;
            }
            setRoomListMobs([...mobs]);
        }
    }

    function updateEquipment(data) {
        useInventoryStore.getState().updateEquipment(data);
    }

    function updateInventory(data) {
        useInventoryStore.getState().updateInventory(data);
    }

    function updateShop(data) {
        const { id, list } = parseShopList(data);
        setShopList({ shopId: id, list: list });
    }

    function updateCraft(data) {
        useCraftStore.getState().setCraftList(data);
        useCraftStore.getState().setShowCraft(true);
    }
    function updateCraftInfo(data) {
        useCraftStore.getState().setCraftInfo(getItemInfo(data));
    }

    function parseShopList(data) {
        if (data.includes(';')) {
            const split = data.split(';');
            const id = split[0];
            const list = [];
            for (let i = 1; i < split.length - 1; i++) {
                const itemData = split[i].split(',');
                const itemId = itemData[0];
                const picId = itemData[1];
                const colour = itemData[2].replace('{c}', '#');
                const curSockets = parseInt(itemData[3]);
                const maxSockets = parseInt(itemData[4]);
                const curCap = parseInt(itemData[5]);
                const maxCap = parseInt(itemData[6]);
                const name = itemData[7];
                const type = itemData[8];
                const type2 = itemData[9];
                const cost = parseInt(itemData[10]);
                let amount = 1;
                let isUnique = false;
                let tag = "";
                if (itemData.length >= 13) {
                    amount = parseInt(itemData[11]);
                    isUnique = itemData[12];
                    tag = itemData[13];
                }

                list.push({
                    itemId,
                    picId,
                    colour,
                    curSockets,
                    maxSockets,
                    curCap,
                    maxCap,
                    name,
                    type,
                    type2,
                    cost,
                    amount,
                    isUnique,
                    tag
                })
            }
            return { id, list };
        }
    }

    function updateShopInfo(data) {
        if (data.includes(';')) {
            const itemInfo = getItemInfo(data);
            setShopInfo(itemInfo);
        }
    }

    function updateInventoryInfo(data) {
        if (data.includes(';')) {
            const itemInfo = getItemInfo(data);
            useInventoryStore.getState().updateInventoryInfo(itemInfo);
        }
    }

    function getItemInfo(data) {
        const parse = data.split(';');
        const picId = parseInt(parse[0]);
        const name = parse[1];
        const description = parse[2];
        const type = parse[3];
        const type2 = parse[4];
        const val = parseInt(parse[5]);
        const speed = parseInt(parse[6]);
        const requirements = [];
        const modifiers = [];
        const uniModifiers = [];
        const socketItems = [];
        const craftReq = [];
        // const procs = [];

        let curSockets = 0;
        let maxSockets = 0;

        if (parse.length >= 8) {
            const req = parse[7];
            if (req.includes('/')) {
                let split = req.split('/');
                split.forEach((e, i) => {
                    if (i < split.length - 1) {
                        const d = e.split(':');
                        const meetsRequirement = (d[2] === 'true');
                        requirements.push({ name: d[0], val: d[1], meetsRequirement });
                    }
                });
            }
        }
        if (parse.length >= 9) {
            const mods = parse[8];
            if (mods.includes('/')) {
                let split = mods.split('/');
                split.forEach((e, i) => {
                    if (i < split.length - 1) {
                        const d = e.split(':');
                        modifiers.push({ name: d[0], val: d[1] });
                    }
                });
            }
        }
        if (parse.length >= 10) {
            for (let i = 9; i < parse.length; i++) {
                if (!parse[i].includes(' ')) {
                    continue;
                }

                const modType = parse[i].slice(0, parse[i].indexOf(' ')).trim();
                const data2 = parse[i].slice(parse[i].indexOf(' '), parse[i].length).trim();

                switch (modType) {
                    case 'mod':
                        if (data2.includes('/')) {
                            const umod = data2.split('/');
                            umod.forEach(m => {
                                if (m.includes(':')) {
                                    const info = m.split(':');
                                    if (info.length > 0) {
                                        uniModifiers.push({ name: info[0], val: info[1] });
                                    }
                                }
                            });
                        }
                        break;
                    case 'sock':
                        if (data2.includes("/")) {
                            const split2 = data2.substring(data2.indexOf("/") + 1).trim().split("/");
                            const sdata = data2.substring(0, data2.indexOf("/"));
                            const s2 = sdata.split(":");
                            maxSockets = parseInt(s2[0].trim());
                            curSockets = parseInt(s2[1].trim());
                            let count = 1;
                            for (const s of split2) {
                                const pr = s.split(":");
                                if (pr.length === 2) {
                                    const rName = pr[0].trim();
                                    const rVal = pr[1].trim();
                                    const mods = rVal.split(",");
                                    for (let mi = 0; mi < mods.length; mi++) {
                                        if (mods[mi].length > 0) {
                                            if (mi === 0) {
                                                socketItems.push({ name: count++ + '. ' + rName, value: mods[mi] });
                                            } else {
                                                socketItems.push({ name: "", value: mods[mi] });
                                            }
                                        }
                                    }
                                }
                            }

                            if (socketItems.length < maxSockets) {
                                for (let i = curSockets; i < maxSockets; i++) {
                                    socketItems.push({ name: count++ + '. Empty.', value: "" });
                                }
                            }
                        }
                        break;
                    case "craft":
                        const creq = data2.split('/');
                        creq.forEach((e, i) => {
                            const d = e.split(':');
                            const meetsRequirement = (d[2] === 'true');
                            craftReq.push({ name: d[0], val: d[1], meetsRequirement });
                        });
                        break;
                    default: break;
                }

            }
        }

        const itemInfo = {
            picId,
            name,
            description,
            type,
            type2,
            val,
            speed,
            requirements,
            modifiers,
            uniModifiers,
            curSockets,
            maxSockets,
            socketItems,
            craftReq
        };
        return itemInfo;
    }

    function removeBuff(data) {
        setBuffs(prev => prev.filter(b => b.uuid !== data));
    }

    function updateBuffs(data) {
        const split = data.split(';');
        const now = Date.now();

        // Create a map of new buffs for efficient lookup
        const newBuffsMap = new Map();

        // Process new buffs
        split.forEach(s => {
            if (s.length > 0) {
                const info = s.split('/');
                const uuid = info[0];
                const picId = parseInt(info[1]);
                const name = info[2];
                const shortName = info[3];
                const description = info[4];
                const duration = parseInt(info[5]);
                const isDebuff = info[6] === 'true';

                newBuffsMap.set(uuid, {
                    uuid,
                    picId,
                    name,
                    shortName,
                    description,
                    duration,
                    createdAt: now,
                    isDebuff
                });
            }
        });

        // Update buffs state
        setBuffs(prevBuffs => {
            // Filter out buffs that are no longer present
            const updatedBuffs = prevBuffs.filter(buff => {
                // Keep buff if it exists in new buffs
                if (newBuffsMap.has(buff.uuid)) {
                    // Update the existing buff with new data
                    const newBuff = newBuffsMap.get(buff.uuid);
                    newBuffsMap.delete(buff.uuid); // Remove from map as it's been handled
                    return true;
                }
                return false; // Remove buff if it's not in new buffs
            });

            // Add any completely new buffs
            const newBuffs = Array.from(newBuffsMap.values());
            return [...updatedBuffs, ...newBuffs];
        });
    }

    function updateUserBuffs(data) {
        // Data format: uuid;picId;name;shortName;description;duration;isDebuff;targetId
        const split = data.split(';');
        if (split.length >= 8) {
            const uuid = split[0];
            const picId = parseInt(split[1]);
            const name = split[2];
            const shortName = split[3];
            const description = split[4];
            const duration = parseInt(split[5]); // duration in milliseconds
            const isDebuff = split[6] === 'true';
            const targetId = split[7].trim();

            // Calculate expiration time
            const expirationTime = Date.now() + duration;

            const buff = {
                uuid,
                picId,
                name,
                shortName,
                description,
                expirationTime,
                isDebuff
            };

            useUserBuffStore.getState().addBuff(targetId, buff);
        }
    }

    function removeUserBuffs(data) {
        // Data format: uuid;targetId
        const split = data.split(';');
        if (split.length >= 2) {
            const uuid = split[0];
            const targetId = split[1].trim();
            useUserBuffStore.getState().removeBuff(targetId, uuid);
        }
    }

    function parseAbilityRequirements(data) {
        const requirements = [];
        const req = data.split('-');
        req.forEach(r => {
            if (r.includes(':')) {
                const info = r.split(':');
                if (info.length > 0) {
                    requirements.push({ name: info[0], val: info[1], meetRequirement: info[2] });
                }
            }
        })
        return requirements;
    }

    function parseAbilityModifiers(data) {
        const modifiers = [];
        const mod = data.split('¬');
        mod.forEach(m => {
            if (m.includes(':')) {
                const info = m.split(':');
                modifiers.push({ name: info[0], val: info[1] });
            }
        })
        return modifiers;
    }


    function updateStamina(data) {
        if (data.includes('/')) {
            const stamina = data.split('/');
            const type = stamina[0];
            const time = parseInt(stamina[1]);
            setStamina({ type: type, duration: time, casting: true });
        } else {
            const time = parseInt(data);
            setStamina({ type: 'stamina', duration: time, casting: false });
        }
    }


    function updateGold(data) {
        usePlayerStore.getState().setGold(parseInt(data));
    }

    function updateMap(data) {
        const mapData = data.split('#');
        const grid = [];

        for (let i = 0; i < mapData.length - 1; i++) {
            if (mapData[i].length > 1) {
                const parts = mapData[i].split('/');
                const color = parts[0];
                const exits = parts[1] ? parts[1].split(';').filter(e => e.length > 0) : [];
                grid.push({ color, exits });
            } else {
                grid.push({ color: '5,5,5', exits: ['n','s','e','w'] });
            }
        }
        setMapGrid(grid);
    }

    function updateMapPosition(data) {
        const pos = data.split("/");
        setPosition([parseInt(pos[0]) + 1, parseInt(pos[1]) + 1]);
    }

    function updateHealth(data) {
        const val = data.split('-');
        usePlayerStore.getState().setHealth(val[0], val[1]);
    }

    function updateMana(data) {
        const val = data.split('-');
        usePlayerStore.getState().setMana(val[0], val[1]);
    }

    function updateExperience(data) {
        const val = data.split('/');
        usePlayerStore.getState().setExperience(val[0], val[1])
    }


    function updateRoomInfo(data) {
        const splitRoom = data.split(';');
        const area = splitRoom[0];
        const title = splitRoom[1];
        const exits = splitRoom[2];
        const desc = splitRoom[3];
        let items = [];
        if (splitRoom.length >= 6) {
            const itemData = splitRoom[5].split('~');
            if (itemData.length === 2) {
                items = parseRoomItems(itemData[1]);
            }
        }

        // const something1 = splitRoom[4];
        // const something2 = splitRoom[5];

        const newInfo = { area: area, title: title, exits: exits, desc: desc, items };

        setRoomInfo(newInfo);
    }

    function updateDisplay(data) {
        const consoleFlag = data.charAt(0);  // '0' = primary, '1' = secondary
        const messageData = data.substring(1);  // Rest of message (without flag)
        const parsed = parseText(messageData);

        const { showSecondConsole, showTimestamps, addMessage, addMessage2 } = useMessageStore.getState();

        let timestampDisplay = null;
        if (showTimestamps) {
            const now = new Date();
            timestampDisplay = `${String(now.getHours()).padStart(2, '0')}:${String(now.getMinutes()).padStart(2, '0')}:${String(now.getSeconds()).padStart(2, '0')}`;
        }

        // Route to appropriate console (fallback to primary if second console disabled)
        if (consoleFlag === '1' && showSecondConsole) {
            addMessage2(parsed, null, timestampDisplay);
        } else {
            addMessage(parsed, null, timestampDisplay);
        }
    }

    async function login(username, password) {
        const pw = await hash(password);
        connect(username, pw);
    }

    async function register(username, password, email) {
        const pw = await hash(password);
        registerAccount(username, pw, email);
    }

    // formatText factory function - creates formatter with state for each message
    function createFormatText(state) {
        return function formatText(text) {
            if (text.length < 2) return null;

            const type = text.substring(0, 2);
            let msg = "";

            switch (type) {
                case 'c}':
                    state.colour = "#" + text.substring(2, 8);
                    msg = text.substring(8);
                    break;
                case 'u}':
                    state.underline = !state.underline;
                    msg = text.substring(2);
                    break;
                case 'b}':
                    state.bold = !state.bold;
                    msg = text.substring(2);
                    break;
                case 'l}':
                    state.link = !state.link;
                    msg = text.substring(2);
                    break;
                case 'h}':
                    break;
                default:
                    break;
            }

            if (!msg) return null;

            state.counter++;
            const fontWeight = state.bold ? '800' : '500';
            const textDecoration = state.underline ? 'underline' : 'none';

            if (state.link) {
                // Optimize link parsing - reduce substring calls
                const semicolonIndex = msg.indexOf(';');
                if (semicolonIndex === -1) {
                    return {
                        text: msg,
                        color: state.colour,
                        fontWeight: fontWeight,
                        textDecoration: textDecoration,
                        isLink: false,
                        linkCommand: null,
                        key: state.counter
                    };
                }
                const len = Number(msg.substring(0, semicolonIndex));
                const afterSemicolon = msg.substring(semicolonIndex + 1);
                const cmd = afterSemicolon.substring(0, len);
                const msg2 = afterSemicolon.substring(len + 1);

                return {
                    text: msg2,
                    color: state.colour,
                    fontWeight: fontWeight,
                    textDecoration: textDecoration,
                    isLink: true,
                    linkCommand: cmd,
                    key: state.counter
                };
            }

            return {
                text: msg,
                color: state.colour,
                fontWeight: fontWeight,
                textDecoration: textDecoration,
                isLink: false,
                linkCommand: null,
                key: state.counter
            };
        };
    }

    function parseText(message) {
        const temp = message.substring(1).split('{');  // Skip first char (was 2 before console flag extraction)
        // Reset formatting state for each message (no shared state)
        const state = {
            underline: false,
            bold: false,
            link: false,
            colour: "#ffffff",
            counter: 0
        };

        const formatText = createFormatText(state);

        // Single-pass filtering using reduce instead of map().filter()
        const result = [];
        for (let i = 0; i < temp.length; i++) {
            const item = formatText(temp[i]);
            if (item !== null) {
                result.push(item);
            }
        }
        return result;
    }

    const sendMessage = (message) => {
        socket.send(message);
    }
    async function hash(string) {
        const utf8 = new TextEncoder().encode(string);
        const hashBuffer = await crypto.subtle.digest('SHA-256', utf8);
        const hashArray = Array.from(new Uint8Array(hashBuffer));
        const hashHex = hashArray
            .map((bytes) => bytes.toString(16).padStart(2, '0'))
            .join('');
        return hashHex;
    }

    const onClick = (e) => {
        socket.send(e);
    }

    const closeServerNotification = () => {
        setServerNotification({ show: false, title: '', message: '' });
    }

    // Memoize context value to prevent unnecessary re-renders of all context consumers
    const contextValue = useMemo(() => ({
        roomListMobs, roomListPlayers, stamina, selfTargeted
    }), [roomListMobs, roomListPlayers, stamina, selfTargeted]);

    if (loggedIn) {
        if (playing) {
            return (
                <AppState.Provider value={contextValue}>
                    <Main sendMessage={sendMessage} roomInfo={roomInformation} mapInfo={mapGrid} position={position} shopList={shopList} shopInfo={shopInfo} buffs={buffs} cooldowns={cooldowns} removeCooldowns={removeCooldowns} notifications={notifications} updateNotification={updateNotification} />
                    <ServerNotificationModal
                        show={serverNotification.show}
                        title={serverNotification.title}
                        message={serverNotification.message}
                        onClose={closeServerNotification}
                    />
                    <AuctionInfoModal open={auctionInfoModalOpen} itemInfo={auctionItemInfo} onClose={() => setAuctionInfoModalOpen(false)} />
                </AppState.Provider>
            );
        }
        return (
            <>
                <Account characterList={characterList} onClick={onClick} createInfo={createInfo} />
                <ServerNotificationModal
                    show={serverNotification.show}
                    title={serverNotification.title}
                    message={serverNotification.message}
                    onClose={closeServerNotification}
                />
                <AuctionInfoModal open={auctionInfoModalOpen} itemInfo={auctionItemInfo} onClose={() => setAuctionInfoModalOpen(false)} />
            </>
        )
    } else {
        return (
            <>
                <Login login={login} register={register} connecting={connecting} connected={connected} loggedIn={loggedIn} />
                <ServerNotificationModal
                    show={serverNotification.show}
                    title={serverNotification.title}
                    message={serverNotification.message}
                    onClose={closeServerNotification}
                />
                <AuctionInfoModal open={auctionInfoModalOpen} itemInfo={auctionItemInfo} onClose={() => setAuctionInfoModalOpen(false)} />
            </>
        )
    }
}

export default Home;